import { compose, withHandlers } from 'recompose'
import React from 'react'
import { reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'

import {
  Input,
  Button,
  Select
} from '../uiLib'
import {
  getPATSCode
} from '../../reducers/security-code'
import { defaultValidators, reduxErrorFormatter } from '../../lib/validation'
import SecurityCodeRequestStatus from './SecurityCodeRequestStatus'
import { notify } from '../../lib/notification'
import NotePanel from './NotePanel'
import InCodeDiagram from './InCodeDiagram'

const reasonCodes = [
  { value: 'PCMReplacement', label: 'PCMReplacement' },
  { value: 'ReprogramKey', label: 'ReprogramKey' }
]


const PATCodeForm = props => {
  const { t, loading, user } = props
  return (
    <div className="immob-form immob-form--code">
      <span className="immob-eyebrow">{t('common:pats-eyebrow-codeword')}</span>
      <h1 className="immob-form-title">{t('common:pats-page-content-12')}</h1>

      { props.pats.request_sent ? (
        <SecurityCodeRequestStatus
          securityCode={props.pats}
          setCodeType={props.setCodeType}
          handleResetForm={props.handleResetForm}
          type="pats"
          t={t}
        />
      ) : (
        <div className="immob-form-grid">
          <div className="immob-form-main">
            <p className="immob-intro">{t('common:pats-page-content-14')}</p>
            <div className="immob-warning">{t('common:pats-page-content-18')}</div>

            <form onSubmit={props.handleSubmit(props._handleSubmit)}>
              <Input
                id="vin"
                name="vin"
                size="normal"
                label={t('common:vin')}
                formComponent
                type="text"
                placeholder={t('common:enter-vin')}
                disabled={loading}
                validate={[
                  defaultValidators.required,
                  defaultValidators.length(17)
                ]} />
              <Input
                id="part_number"
                name="part_number"
                size="normal"
                label={t('common:part-number')}
                formComponent
                type="text"
                placeholder={t('common:enter-part-number')}
                disabled={loading}
                validate={[
                  defaultValidators.required
                ]} />
              <Input
                id="serial_number"
                name="serial_number"
                size="normal"
                label={t('common:serial-number')}
                formComponent
                type="text"
                placeholder={t('common:enter-serial-number')}
                disabled={loading}
                help={t('common:serial-number-help')}
                validate={[
                  defaultValidators.required
                ]} />
              <Input
                id="error_control_number"
                name="error_control_number"
                size="normal"
                label={t('common:error-control-number')}
                formComponent
                type="text"
                placeholder={t('common:enter-error-control-number')}
                disabled={loading}
                validate={[
                  defaultValidators.required
                ]} />
              <Input
                id="out_code"
                name="out_code"
                size="normal"
                label={t('common:out-code')}
                formComponent
                type="text"
                placeholder={t('common:enter-out-code')}
                disabled={loading}
                help={
                  <React.Fragment>
                    {t('common:out-code-help')}
                    <br />
                    {t('common:out-code-help-2')}
                  </React.Fragment>
                }
                validate={[
                  defaultValidators.required,
                  defaultValidators.maxLength(32)
                ]} />
              <Select
                id="reason"
                name="reason"
                label={props.t('common:reason')}
                size="normal"
                required
                formComponent
                placeholder={props.t('common:please-select')}
                validate={[defaultValidators.required]}
                values={reasonCodes}
              />
              <p className="immob-intro">{t('common:pats-page-content-20')}</p>
              <div className="immob-actions">
                <Button
                  type="button"
                  btType="default"
                  onClick={() => props.setCodeType('')}
                  disabled={loading}
                >
                  {t('common:back')}
                </Button>
                <Button
                  btType="primary"
                  disabled={loading}
                  loading={loading}
                >
                  {t('common:submit')}
                </Button>
              </div>
            </form>
          </div>

          <div className="immob-help">
            <NotePanel t={t} user={user} />
            <div className="immob-outin">
              <span className="immob-outin-title">{t('common:pats-outin-code-title')}</span>
              <p className="immob-outin-body">{t('common:pats-outin-code-body')}</p>
              <InCodeDiagram t={t} />
              {/*
                FALLBACK: original instructional image. If the client prefers the
                photo over the CSS diagram above, delete the <InCodeDiagram /> line
                and uncomment this block.
                <img src="/static/images/mdars.jpg" alt="Immobilizer In Code example" style={{ maxWidth: '100%' }} />
              */}
            </div>
          </div>
        </div>
      ) }
    </div>
  )
}

const mapStateToProps = state => ({
  pats: state.securityCode.pats,
  loading: state.securityCode.loading,
  error: state.securityCode.error
})

const mapDispatchToProps = dispatch => ({
  createNotification: opts => dispatch(notify(opts)),
  getPATSCode: car_data => dispatch(getPATSCode(car_data))
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    _handleSubmit: ({ getPATSCode,t ,createNotification }) => data => {
      return getPATSCode(data)
      .catch(err => {
        let reduxFormErr = {
          _error: t('server-error')
        }

        if (err.response.status === 400) {
          reduxFormErr = {
            ...reduxFormErr,
            ...reduxErrorFormatter(err.response.data)
          }
        } else {
          createNotification({
            type: 'error',
            message: t('server-error')
          })
        }
        throw new SubmissionError(reduxFormErr)
      })
    }
  }),
  reduxForm({
    destroyOnUnmount: false,
    form: 'pat_code'
  })
)(PATCodeForm)



// WEBPACK FOOTER //
// ./components/PATSCodes/PATCodeForm.js